<template>
    <v-flex>
        <v-layout row class="content-header">
            <v-flex md12 class="content-title">
                <!-- <h2>Comissões odonto</h2> -->
                <h2>Comissões Produtos Parceiros</h2>
                <h4>Informações sobre comissionamento de produtos garantidos por empresas parceiras da Previsul</h4>
            </v-flex>
            <v-flex md12>
                <br>
                <div class="line"></div>
            </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <br /><br />
                <p>
                    Odonto +: envie e-mail para pós-venda.afinidades@odontoempresas.com.br
                </p>                 
                <!-- <p>
                   Consórcio +: você receberá por e-mail o relatório de comissionamento da Caixa Consórcio até o 5º dia útil do mês subsequente da venda. Em caso de dúvidas, procure seu consultor Previsul.
                </p> -->
                <!-- <v-data-table
                    :headers="headers"
                    :items="recibos"
                    :items-per-page="8"
                    class="">
                    <template v-slot:item.excel="{ item }">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30">
                            <defs>
                                <path id="aexcel" d="M29.631 6.495L23.481.363A1.23 1.23 0 0 0 22.613 0H2.435A2.438 2.438 0 0 0 0 2.45v25.1C0 28.903 1.09 30 2.435 30h25.107a2.427 2.427 0 0 0 2.435-2.419L30 7.368a1.317 1.317 0 0 0-.369-.873zm-1.137 5.026l-.007 7.607v7.99c0 .726-.6 1.321-1.33 1.321H2.828a1.33 1.33 0 0 1-1.329-1.321V2.805c0-.726.6-1.321 1.33-1.321h16.244c.73 0 1.329.595 1.329 1.321V6.72c0 1.469 1.13 2.635 2.62 2.635h4.144c.73 0 1.33.595 1.33 1.322v.845zm-17.206 2.462a.979.979 0 0 0-.99.965v6.044c0 .533.437.965.99.965h17.457v-7.974H11.288zm5.356 6.893l-1.412-2.246-1.412 2.246h-1.366l2.01-3.056-1.887-2.872h1.42l1.304 2.13 1.282-2.13h1.388l-1.903 2.941 2.05 2.987h-1.474zm2.233 0v-5.935h1.281v4.893h2.456l.008 1.042h-3.745zm7.788-.386c-.39.31-.936.463-1.642.463-.644 0-1.22-.115-1.71-.355v-1.165c.406.177.751.309 1.043.378.284.07.545.108.775.108.284 0 .498-.054.644-.154.146-.1.23-.263.23-.471a.495.495 0 0 0-.1-.309 1.109 1.109 0 0 0-.29-.262c-.131-.085-.392-.216-.784-.402-.368-.17-.644-.332-.836-.494a1.792 1.792 0 0 1-.445-.548c-.115-.208-.161-.455-.161-.733 0-.525.184-.934.545-1.235.36-.301.867-.455 1.504-.455.314 0 .614.038.905.108.292.07.583.177.898.308l-.414.973a6.45 6.45 0 0 0-.798-.27 2.551 2.551 0 0 0-.63-.077c-.245 0-.43.054-.56.17a.555.555 0 0 0-.2.44.54.54 0 0 0 .077.293.85.85 0 0 0 .254.24c.115.076.39.215.82.416.568.262.96.532 1.167.803.215.262.315.594.315.98-.016.517-.208.95-.607 1.25z"/>
                            </defs>
                            <g fill="none" fill-rule="evenodd">
                                <path fill="#FFF" fill-rule="nonzero" d="M29.631 6.495L23.481.363A1.23 1.23 0 0 0 22.613 0H2.435A2.438 2.438 0 0 0 0 2.45v25.1C0 28.903 1.09 30 2.435 30h25.107a2.427 2.427 0 0 0 2.435-2.419L30 7.368a1.317 1.317 0 0 0-.369-.873z"/>
                                <mask id="bexcel" fill="#fff">
                                    <use xlink:href="#aexcel"/>
                                </mask>
                                <use fill="#26C184" fill-rule="nonzero" xlink:href="#aexcel"/>
                                <g fill="#64A70B" mask="url(#bexcel)">
                                    <path d="M0 0h30v30H0z"/>
                                </g>
                            </g>
                        </svg>
                    </template>
                    <template v-slot:item.pdf="{ item }">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30">
                            <defs>
                                <path id="apdf" d="M29.631 6.495c.23.24.361.557.369.873l-.023 20.213A2.427 2.427 0 0 1 27.542 30H2.435A2.443 2.443 0 0 1 0 27.55V2.45A2.438 2.438 0 0 1 2.435 0H22.613c.323 0 .638.131.868.363l6.15 6.132zm-1.137 5.026v-.845c0-.727-.599-1.322-1.329-1.322h-4.144c-1.49 0-2.62-1.166-2.62-2.635V2.805c0-.726-.6-1.321-1.33-1.321H2.828a1.33 1.33 0 0 0-1.329 1.321v24.313c0 .726.6 1.321 1.33 1.321h24.33a1.33 1.33 0 0 0 1.329-1.321l.007-15.597zm-10.643 6.45a23.198 23.198 0 0 1 3.197-.248c1.344.016 2.235.223 2.631.627.138.131.267.338.292.51.073.578.016 1.122-.243 1.526a.997.997 0 0 1-.607.42c-.17.05-.38.074-.615.074-1.352 0-3.49-.692-5.222-1.681a45.382 45.382 0 0 0-7.155 1.73C8.153 24.435 6.713 26 5.482 26c-.235 0-.461-.05-.672-.165l-.494-.247c-.307-.173-.356-.56-.291-.866.194-.956 1.344-2.152 3.076-3.207.21-.115 1.077-.593 1.117-.61l.502-.272a67.831 67.831 0 0 0 1.635-3.067l.073-.156c.567-1.13 1.222-2.424 1.732-3.702l.178-.47c-.712-2.803-1.117-4.98-.728-6.422.121-.47.607-.816 1.198-.816h.008l.308.05c.534-.017.874.453 1.044.857l.057.148c.04.14.056.182.08.355.162 1.245-.469 4.913-.469 4.913-.032.14-.065.272-.105.429.583 1.624 1.522 3.116 2.647 4.188.42.396.955.725 1.473 1.03zM5.207 25.067c.607-.28 1.53-1.178 2.914-3.413-.194.182-.389.38-.478.446-1.319 1.096-2.21 2.34-2.436 2.967zM13.018 6.75c-.186 0-.17 1.451-.17 1.451 0 .759.106 1.913.332 2.646.284-.502.494-1.17.478-2.126-.016-.949-.243-1.97-.64-1.97zm-2.33 13.05c1.513-.593 3.237-1.088 5.253-1.483-.138-.108-.267-.207-.389-.314-.987-.857-1.821-1.912-2.493-3.149-.34.882-.793 1.97-1.514 3.347l-.858 1.6zm11.988-.75c-.713-.181-.923-.181-1.644-.181-.396 0-.833.016-1.32.058 1.247.544 2.146.882 2.866.882.227 0 .575-.041.697-.124.121-.082.113-.453-.6-.635z"/>
                            </defs>
                            <g fill="none" fill-rule="evenodd">
                                <path fill="#FFF" fill-rule="nonzero" d="M28 12.054l-.008 15.622c0 .728-.599 1.324-1.329 1.324H2.33C1.6 29 1 28.404 1 27.676V3.324C1 2.596 1.6 2 2.33 2h16.246c.73 0 1.33.596 1.33 1.324v3.92c0 1.471 1.129 2.64 2.62 2.64h4.145c.73 0 1.329.596 1.329 1.323v.847z"/>
                                <mask id="bpdf" fill="#fff">
                                    <use xlink:href="#apdf"/>
                                </mask>
                                <use fill="#FB6363" fill-rule="nonzero" xlink:href="#apdf"/>
                                <g fill="#E34F4F" mask="url(#bpdf)">
                                    <path d="M0 0h30v30H0z"/>
                                </g>
                            </g>
                        </svg>        
                    </template>
                </v-data-table> -->
            </v-flex>
            <v-flex md12>

            </v-flex>            
        </v-layout>
    </v-flex>
</template>

<script>

    import { mapState, mapGetters } from 'vuex';
    export default {
        data() {
            return {
                headers: [
                    {text: "Id", value: "id", sortable: false},
                    {text: "Data", value: "data", sortable: false},
                    {text: "", value: "excel", sortable: false},
                    {text: "", value: "pdf", sortable: false}
                ],
                recibos: [
                    {
                        id: "1",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "2",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "3",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "4",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "5",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "6",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "7",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "8",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "9",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "10",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "11",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "12",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "13",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "14",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "15",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "16",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "17",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "18",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "19",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "20",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "21",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "22",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "23",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "24",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                    {
                        id: "25",
                        data: "30/08/2019",
                        excel: "anexo1.xls",
                        pdf: "anexo1.pdf"
                    },
                 ]
            }
        },        
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        mounted(){
            this.usuario;
        }
    }
</script>
